<template>
    <section class="no-notification p-2 mt-2">
        <div class="noti-container">
            <!-- <div class="no-notification-icon">
                <img loading="lazy" :src="mergedNoDataBody.image" alt="no-data-img">
            </div> -->
            <div class="thm-heading">
               <h3>{{ $t('no-data-found','No data found!')}}</h3>
                <p>{{ $t("we-cant-find-any-item-matching-your-search","we couldn't find any match.")}}</p>
                <!-- <p>{{mergedNoDataBody.message}}</p> -->
            </div>
            <!-- <div class="thm-heading mt-lg-4 mt-2 data-btn">
                <a  class="thm-but ">Go back </a>
            </div> -->
        </div>
    </section>
</template>

<script>
export default {
    name: "NoDataFound",
    props: {
        noDataBody: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        mergedNoDataBody() {
            return {
                image: require("@/assets/images/no-data-img.webp"),
                header: "No Data Found!",
                message: "We can't find any item matching your search.",
                ...this.noDataBody
            };
        }
    }
}
</script>